import styled from 'styled-components';
import Wra16A from 'dc/Wra16A';
import ProgressCircle from 'dc/ProgressCircle';
import { Typ70, Typ20 } from 'dc/Typ';

export const Wrapper = styled(Wra16A)`
  background-color: transparent;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const Circle = styled(ProgressCircle)`
  margin: 16px auto 32px;
`;

export const Title = styled(Typ70)``;

export const Text = styled(Typ20)`
  text-align: center;
`;
